/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

import React from "react";

export default function SavoirFaire() {
  return (
    <section className="chapter">
      <header className="chapter__header">
        <h2 className="chapter__title">Promoteurs de savoir-faire</h2>
        <p className="chapter__subtitle">
          Un espace dédié à la valorisation des compétences et expertises métiers
        </p>
      </header>

      <div className="chapter__content">
        <p className="chapter__intro">
          Le projet <strong>myBusinessPartner</strong> vise à construire un réseau de confiance, porteur de solutions concrètes pour les entreprises romandes.
          Au fil de ma carrière de consultant, j’ai trop souvent entendu : “Nous sommes dans le rouge”, “Nous ne trouvons pas de collaborateurs”, ou encore “Notre expert est parti, et nous aurions aimé continuer à travailler avec lui.”
          Les entreprises romandes aspirent à des collaborations durables, basées sur la fiabilité et la continuité des compétences mobilisées dans leurs projets.<br/><br/>
          Mon objectif est donc de constituer un réseau de partenaires recommandés par ceux qui les ont déjà sollicités, tout en offrant une première chance aux nouveaux acteurs du marché.
          Ayant agi pendant de nombreuses années comme <em>problem solver</em> auprès de divers clients, je souhaite aujourd’hui mobiliser mon réseau pour apporter des solutions concrètes, via les partenaires du projet, aux entreprises qui en ont besoin.
          Les métiers évoluent, et ce réseau a vocation à s’enrichir continuellement de nouvelles expertises.<br/><br/>
          Cet ensemble de savoir-faire servira également à soutenir les projets qui rejoindront  <a href='https://land-of-innovation.ch' target='_blank' rel='noopener noreferrer'>le coeur de l'innovation</a>.
        </p>

        <div className="chapter__block">
          <h3 className="chapter__block-title">Domaines d’expertise</h3>
          <p className="chapter__block-text">
            Le réseau sera enrichi progressivement. Le projet pourra intégrer de nouveaux domaines ou déléguer à des partenaires plus spécialisés.
            Par exemple, dans les secteurs du bâtiment, de l’entretien ou de la réflexion stratégique, j’ai eu la chance de collaborer avec des entreprises qui pourraient devenir des piliers du projet, en mobilisant leur réseau et leurs compétences.
            Dans ces cas, <strong>myBusinessPartner</strong> agira principalement comme apporteur d’affaires.
          </p>
        </div>

        <div className="chapter__block">
          <h3 className="chapter__block-title">Domaines ouverts aux nouveaux partenaires</h3>
          <p className="chapter__block-text">
            À ce stade, nous commençons à agréger des compétences dans les domaines de l’informatique (mon cœur de métier) et de l’immobilier, notamment les régies immobilières, secteur dans lequel j’ai eu le plaisir d’intervenir en tant qu’informaticien.
            Au fur et à mesure de l’arrivée de nouveaux partenaires et de notre capacité à structurer d’autres domaines de manière professionnelle, ceux-ci seront intégrés à la plateforme <strong>myBusinessPartner</strong>.
          </p>
        </div>

        <div className="chapter__block">
          <h3 className="chapter__block-title">Modalités d’adhésion</h3>
          <p className="chapter__block-text">
            Certaines sociétés avec lesquelles j’ai collaboré seront invitées à rejoindre le projet. Si vous souhaitez proposer vos services dans ce cadre, je vous invite à entrer dans le processus de sélection en me contactant via mon profil LinkedIn dédié à ces initiatives :<br/>
            <strong>myBusinessPartner, Open-Market et Land-Of-Innovation</strong>.<br/><br/>
            <a href='https://www.linkedin.com/in/responsable' target='_blank' rel='noopener noreferrer'>Rejoignez-moi sur LinkedIn</a>.<br/><br/>
            <strong>Condition :</strong> être une entreprise romande enregistrée dans l’annuaire des sociétés suisses. Lors de votre demande, merci de transmettre votre numéro IDE. Les candidatures incomplètes ne seront pas prises en compte.
          </p>
        </div>

        <div className="chapter__block">
          <h3 className="chapter__block-title">Références et recommandations</h3>
          <p className="chapter__block-text">
            Dans le cadre de l’évaluation de votre savoir-faire et de votre savoir-être, il vous sera demandé de fournir des références clients satisfaits, avec leur accord préalable, afin que je puisse les contacter.
          </p>
        </div>
      
      
        <div className="chapter__block">
        <h3 className="chapter__block-title">Comment cela coûte</h3>
        <p className="chapter__block-text">
          Pour la première année de fonctionnement, il a été décidé de ne pas facturer d'abonnement. <br />
          Vous recevrez un bulletin de versement avec CHF 20.- comme participation aux frais de fonctionnement, indépendamment du fait que la plateforme vous fournisse des opportunités ou que quelqu'un soit intéressé par celles que vous proposerez. <br />
          Par la suite, si vous souhaitez rester adhérent parce que vous y trouvez un intérêt, en tant que "early adopter", <br />
          vous paierez un abonnement de CHF 240.-/an (hors TVA), soit 50 % du prix normal que paieront <br />
          ceux qui sont frileux, pas sûrs de vouloir rejoindre ce projet innovant, et qui préfèrent attendre qu'il soit à sa vitesse de croisière pour s'inscrire. <br />
          <br />
          Le prix annuel standard a été fixé à CHF 480.- (hors TVA).
          <br/>
          <br/>
          Pour ceux qui souhaiterons nous rejoindre plus tard, le processus de validation sera probablement payant, car en toute logique, je devrai m'appuyer sur des partenaires pour rester focus sur mon coeur de métier.
        </p>
      </div>
      </div>
    </section>
  );
}
